const IconAlertPriority = (): JSX.Element => {
  return (
    <>
      <path
        d="M11.32,0.94c0.42-0.14,0.87-0.14,1.29,0
		l0.21,0.08l0.15,0.08c0.33,0.19,0.56,0.47,0.73,0.7c0.19,0.27,0.4,0.63,0.63,1.02l8.62,14.88l0.32,0.56
		c0.1,0.18,0.19,0.34,0.26,0.49c0.12,0.26,0.25,0.6,0.25,0.99l-0.01,0.17c-0.05,0.52-0.3,0.99-0.68,1.34L22.9,21.4
		c-0.37,0.27-0.79,0.34-1.12,0.37c-0.33,0.03-0.75,0.03-1.2,0.03H3.34c-0.46,0-0.87,0-1.2-0.03c-0.29-0.03-0.64-0.08-0.98-0.28
		L1.02,21.4c-0.42-0.31-0.71-0.76-0.82-1.26l-0.03-0.22c-0.05-0.46,0.1-0.86,0.24-1.16c0.14-0.3,0.35-0.66,0.58-1.06L9.6,2.82
		l0.33-0.56c0.1-0.17,0.2-0.33,0.3-0.47c0.19-0.27,0.46-0.59,0.88-0.78L11.32,0.94z M11.94,3.01c-0.06,0.09-0.13,0.2-0.21,0.34
		l-0.31,0.53L2.8,18.76c-0.25,0.43-0.4,0.69-0.49,0.89c-0.01,0.01-0.01,0.02-0.01,0.03c0.01,0,0.02,0,0.03,0.01
		c0.21,0.02,0.51,0.02,1.01,0.02h17.24c0.5,0,0.8,0,1.01-0.02c0.01,0,0.02,0,0.03-0.01c0-0.01-0.01-0.02-0.01-0.03
		c-0.05-0.1-0.11-0.21-0.19-0.36l-0.3-0.53L12.5,3.87c-0.25-0.43-0.4-0.69-0.52-0.86C11.97,3,11.97,2.99,11.96,2.98
		C11.95,2.99,11.95,3,11.94,3.01z M11.97,16.03l0.11,0.01c0.53,0.05,0.94,0.5,0.94,1.04c0,0.54-0.41,0.99-0.94,1.04l-0.11,0.01
		h-0.01c-0.58,0-1.05-0.47-1.05-1.05c0-0.58,0.47-1.05,1.05-1.05H11.97z M10.91,12.89V8.7c0-0.58,0.47-1.05,1.05-1.05
		c0.58,0,1.05,0.47,1.05,1.05v4.19c0,0.58-0.47,1.05-1.05,1.05C11.38,13.94,10.91,13.47,10.91,12.89z"
      />
    </>
  );
};

export default IconAlertPriority;
